import TokensTableRowActions from './TokensTableRowActions';

export default TokensTableRowActions;